import Keycloak from 'keycloak-js';
import UserTokenFactory from './../services/session/userTokenFactory';
import { EnvironmentService } from '../index';
import { KEYCLOAK_AUTH_URLS, KEYCLOAK_REALM } from '../config/keycloakAuthUrls';

const initializationError = new Error('Keycloak instance not created yet.');

let instance = null;

function getInstance() {
    if (instance === null) {
        throw initializationError;
    }
    return instance;
}

export function getUserToken() {
    const { idToken } = getInstance();
    return UserTokenFactory.create(idToken);
}

function getKeycloakAuthUrlForEnv(env) {
    switch (env) {
        case 'LOCAL':
        case 'TEST':
        case 'INT':
            return KEYCLOAK_AUTH_URLS.INT;
        case 'PROD':
            return KEYCLOAK_AUTH_URLS.PROD;
    }
    throw `No keycloak auth url defined for environment ${env}`;
}

export function login(redirectUri) {
    getInstance().login({ redirectUri });
}

export async function logout() {
    const KeycloakInstance = getInstance();
    return new Promise(resolve => {
        KeycloakInstance.onAuthLogout = resolve;
        KeycloakInstance.logout();
    });
}

export async function init(
    params = {
        promiseType: 'native',
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html'
    }
) {
    return new Promise((resolve, reject) => {
        getInstance()
            .init(params)
            .then(resolve)
            .catch(reject);
    });
}

export function create(
    clientId = 'odm-cockpit',
    url = getKeycloakAuthUrlForEnv(EnvironmentService.getEnvironment()),
    realm = KEYCLOAK_REALM
) {
    const keycloakConfig = {
        clientId,
        url,
        realm
    };

    const requiredConfigKeys = ['clientId', 'url', 'realm'];
    const isValidConfig = requiredConfigKeys.every(requiredConfigKey => Object.keys(keycloakConfig).includes(requiredConfigKey));
    if (!isValidConfig) {
        throw `Required config keys: ${requiredConfigKeys.join(',')}`;
    }
    instance = new Keycloak(keycloakConfig);
    return this;
}

// FOR TESTING
export function __getInstance() {
    return instance;
}
